module.exports = __webpack_public_path__ + "static/media/image_52.6d986fd6.png";